import {
  Currency,
  FiatWalletAccountState,
} from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { useApplyJonumRestriction } from './useApplyJonumRestriction.ts';

export const useRewardCurrency = (): Currency => {
  const { currentUser, fiatWalletAccountable } = useCurrentUserContext();
  const isJonumImpacted = useApplyJonumRestriction();

  const hasActivatedCashWallet =
    fiatWalletAccountable?.state === FiatWalletAccountState.VALIDATED_OWNER;

  // rewardCurrency is force-locked to ETH server-side for these users, so we show FIAT instead.
  const rewardCurrencyForcedToCrypto =
    isJonumImpacted || !hasActivatedCashWallet;

  return rewardCurrencyForcedToCrypto
    ? Currency.FIAT
    : currentUser?.userSettings.rewardCurrency || Currency.ETH;
};
